/**
 * Parses an SSE byte stream (a fetch Response body — works identically for
 * the POST /turns buffered-burst response and the GET /stream live tail,
 * since both use the same wire format) into an async iterable of typed
 * envelopes. No EventSource here deliberately: EventSource cannot be
 * pointed at a POST response body, and packages/client must drive both
 * endpoints uniformly, usable from plain Node with no DOM globals.
 */
export async function* parseSseStream(body) {
    const reader = body.getReader();
    const decoder = new TextDecoder("utf-8");
    let buffer = "";
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            buffer += decoder.decode(value, { stream: true });
            let frameBoundary = buffer.indexOf("\n\n");
            while (frameBoundary !== -1) {
                const frame = buffer.slice(0, frameBoundary);
                buffer = buffer.slice(frameBoundary + 2);
                const envelope = parseFrame(frame);
                if (envelope !== null)
                    yield envelope;
                frameBoundary = buffer.indexOf("\n\n");
            }
        }
    }
    finally {
        reader.releaseLock();
    }
}
function parseFrame(frame) {
    let id = null;
    let type = null;
    let dataRaw = null;
    for (const line of frame.split("\n")) {
        if (line.startsWith("id: "))
            id = Number.parseInt(line.slice(4), 10);
        else if (line.startsWith("event: "))
            type = line.slice(7);
        else if (line.startsWith("data: "))
            dataRaw = line.slice(6);
    }
    if (id === null || type === null || dataRaw === null || Number.isNaN(id))
        return null;
    const data = JSON.parse(dataRaw);
    return { id, type, data };
}
//# sourceMappingURL=sse-parse.js.map